<template>
<div>
  <v-dialog v-model="hataObject.dialog" scrollable persistent max-width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>{{ $t('Critical-Error') }}</v-card-title>
      <v-card-text>
        {{ hataObject.baslik }}
        <br />{{ $t('Please-notify-Arkman-about-error') }}
        <br />{{ $t('Error-details-given-below') }}
        <br />
        <pre> <code> {{ hataObject.response }} 
          Request : {{ hataObject.request }}
        </code> </pre>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="info" flat @click.native="hataObject.dialog=false">{{$t('Close')}}</v-btn>
        <v-btn color="info" flat @click.native="epostagonder()"> {{ $t('Mail-error-Arkman') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-snackbar :timeout="15000" v-model="snackbar">
    {{ snackbarMessage }}
    <v-btn flat @click.native="snackbar = false">{{$t('Close')}}</v-btn>
  </v-snackbar>

</div>
</template>

<script>
import axios from "axios";
import auth from "../../../../api/auth";

export default {
  data() {
    return {
      hataObject: {
        dialog: false,
        response: null,
        baslik: "",
        request: null
      },
      snackbar: false,
      snackbarMessage: false,

    };
  },

  methods: {
    htmlEncode: function (str) {
      str = str.replace(/&/g, '.....');
      str = str.replace(/"/g, "_____");
      str = str.replace(/</g, '-----');
      str = str.replace(/>/g, '+++++');
      return str;
    },

    open(response, request, baslik) {
      (this.hataObject.dialog = true), (this.hataObject.response = response);
      this.hataObject.request = request;
      this.hataObject.baslik = baslik;
    },

    epostagonder() {
      let formData = new FormData();

      formData.append("Konu", "Arkman Next Hata email");
      formData.append("to", "fatih@arkman.com.tr");
      formData.append("mailType", "0");

      let msg1 = JSON.stringify(this.hataObject)

      msg1 = "Bu mesaj ArkmanNext uygulması üzerinden hata formu kullanılarak gönderilmiştir.\n\r " + msg1;

      formData.append(
        "formattedMessage",
        this.htmlEncode(msg1)
      );

      axios.defaults.baseURL = auth.API_URL;

      let credentials = JSON.parse(window.localStorage.getItem("credentials"));

      axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
      axios
        .post(auth.API_URL + "api/Helpers/SendEmail2", formData, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
            CariSirketNo: credentials.SirketKodu.toString(),
            CoperSirketNo: credentials.CoperSirketNo.toString()
          }
        })
        .then(response => {
          if (response.data == true) {
            this.snackbarMessage = "Mail Gönderildi."
            this.snackbar = true
          } else {
            this.snackbarMessage = this.$t('Mail-system-not-right-now-send-manual-mail')
            this.snackbar = true
          }
        })
        .catch((error) => {
          this.snackbarMessage = this.$t('Mail-system-not-right-now-send-manual-mail')
          this.snackbar = true
        });
    }
  }
};
</script>
